/**
 * CategoryBanner — Banners editoriais por categoria esportiva
 *
 * Uses centralized sportsConfig — single source of truth for colors/gradients.
 * Accepts any key: 'swimming', 'natacao', 'football', 'futebol', etc.
 *
 * Usage:
 *   <CategoryBanner category="swimming" />
 *   <CategoryBanner category="natacao" layout="wide" />
 */
import React from 'react';
import { getSport, getSportGradient } from '../../config/sportsConfig';

const CategoryBanner = ({
  category = 'general',
  height = 'h-24 md:h-auto',
  width = 'w-full md:w-44',
  showLabel = true,
  showLogo = true,
  className = '',
  layout = 'sidebar',
}) => {
  const cat = getSport(category);

  if (layout === 'wide') {
    return (
      <div
        className={`w-full relative overflow-hidden ${className}`}
        style={{
          background: cat.gradient,
          height: '120px',
        }}
      >
        {/* Pattern overlay */}
        <div
          className="absolute inset-0"
          style={{ background: cat.pattern }}
        />

        {/* Content */}
        <div className="relative h-full flex items-center justify-between px-8">
          <div>
            {showLogo && (
              <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-white/40 mb-1">
                VUKZ
              </p>
            )}
            {showLabel && (
              <>
                <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-white/50">
                  {cat.sublabel}
                </p>
                <p className="text-xl font-black text-white tracking-wide mt-0.5">
                  {cat.labelUpper}
                </p>
              </>
            )}
          </div>
          <span className="text-5xl opacity-10">{cat.emoji}</span>
        </div>
      </div>
    );
  }

  // Default: sidebar layout (narrow, used in cards)
  return (
    <div
      className={`${width} ${height} relative overflow-hidden flex-shrink-0 ${className}`}
      style={{ background: cat.gradient }}
    >
      {/* Pattern overlay */}
      <div
        className="absolute inset-0"
        style={{ background: cat.pattern }}
      />

      {/* Content centered */}
      <div className="relative h-full flex flex-col items-center justify-center text-center px-3 py-4">
        {showLogo && (
          <p className="text-[8px] font-bold uppercase tracking-[0.3em] text-white/30 mb-1">
            VUKZ
          </p>
        )}
        <span className="text-2xl mb-1 opacity-20">{cat.emoji}</span>
        {showLabel && (
          <>
            <p className="text-[8px] font-semibold uppercase tracking-[0.15em] text-white/40">
              {cat.sublabel}
            </p>
            <p className="text-[11px] font-black text-white/60 tracking-wider mt-0.5">
              {cat.labelUpper}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

// Re-export from sportsConfig for backward compat
export { getSport as getCategoryConfig, getSportGradient as getCategoryGradient } from '../../config/sportsConfig';

export default CategoryBanner;
